import React from "react";
import { Link } from "react-router-dom";

export default function LandingFooter() {
  return (
    <footer className="saas-lp-footer">
      <div className="saas-lp-inner saas-lp-footer__grid">
        <div className="saas-lp-footer__brand">
          <div className="saas-lp-footer__logo">
            <span className="saas-lp-brand__icon">b</span>
            <strong>BEENTARA</strong>
          </div>
          <p>The complete operating system for modern business. Built for growth.</p>
        </div>

        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="/#vision">About Us</a></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4>Ecosystem</h4>
          <ul>
            <li><a href="/#ecosystem">Website Builder</a></li>
            <li><a href="/#ecosystem">Operations</a></li>
            <li><a href="/#ecosystem">Workforce</a></li>
          </ul>
        </div>

        <div>
          <h4>Product</h4>
          <ul>
            <li><a href="/#pricing">Pricing</a></li>
            <li><Link to="/compare">Compare plans</Link></li>
            <li><Link to="/signup">Start trial</Link></li>
          </ul>
        </div>
      </div>

      <div className="saas-lp-inner saas-lp-footer__bottom">
        <p>© 2026 Beentara. All rights reserved.</p>
        <nav>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms-conditions">Terms</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </nav>
      </div>
    </footer>
  );
}
